import React from "react";

const Home = () => {
  return (
    <div>
      <h1 style={{ color: "white" }}>
        Приветствую вас на страницах нашей таблицы! 
      </h1>
      <h1 style={{ color: "white" }}>Выберите сервер!</h1>
    </div>
  );
};

export default Home;